import React, { forwardRef, useCallback } from "react";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
// ToDo: temporarily suppress warning
// eslint-disable-next-line no-unused-vars
const TextMaskPhone = forwardRef((props, ref) => {
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const setRef = useCallback(
    (maskedInputRef) => {
      const value = maskedInputRef ? maskedInputRef.inputElement : null;

      if (typeof ref === "function") {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    },
    [ref]
  );
  if (countryCode === "AU") {
    return (
      <MaskedInput
        {...props}
        ref={setRef}
        mask={[
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
        ]}
      />
    );
  } else {
    return (
      <MaskedInput
        {...props}
        ref={setRef}
        mask={[
          "(",
          /[1-9]/,
          /\d/,
          /\d/,
          ")",
          " ",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ]}
      />
    );
  }
});
TextMaskPhone.displayName = "TextMaskPhone";
TextMaskPhone.propTypes = {
  inputRef: PropTypes.object,
};
export default TextMaskPhone;
